import PropTypes from 'prop-types';
// import { Link as RouterLink } from 'react-router-dom';
// material
import { Box, Card, Stack, Chip, Avatar, Typography, Button, Tooltip, Grid ,IconButton} from '@mui/material';
import { styled } from '@mui/material/styles';
// utils
// import { fCurrency } from '../../utils/formatNumber';
// components
import Label from '../../components/Label';
// import { ColorPreview } from '../../components/color-utils';
import Iconify from 'src/components/Iconify';
import { green } from '@mui/material/colors';
import { LoadingButton } from '@mui/lab';
import { useState } from 'react';
import { handleResponse } from "src/utils/responseHandler"
import axios from 'src/axios'
import { getURL } from 'src/utils/config';


import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import { format } from 'date-fns';

// ----------------------------------------------------------------------
const ProductImgStyle = styled('img')({
  top: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  position: 'absolute',
});
// ----------------------------------------------------------------------

AuditListCard.propTypes = {
  audit: PropTypes.object,
};

function formatDate(datetimeString) {
  // Parse the datetime string into a Date object
  const date = new Date(datetimeString);

  // Extract the components of the date
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based in JavaScript
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  // Construct the formatted date string
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

const MAX_COMMENT_LENGTH = 200;

const formatEventTime = (dateString) => {
  if (!dateString) return 'N/A';
  try {
    return format(new Date(dateString), 'MMM-dd-yyyy hh:mm a');
  } catch (error) {
    return 'Invalid Date';
  }
};

const EVENT_TYPE_FALLBACK_CLIENT_IDS = ['1427', '1428', '1445'];

const isBlankEventType = (value) => {
  const text = String(value ?? '').trim();
  return text === '' || text.toLowerCase() === 'null';
};

export default function AuditListCard({ audit, handleDialog ,handleDialogFav ,isUnviewed}) {
  // const [isSubmitting, setIsSubmitting] = useState(false)
  // const { EventNo, EventType,CameraId, ClientCreatedOn, DetectedType,EventTime, devicename, SnapshotUrl, VideoUrl ,SupervisorComments ,Priority ,IsFavourite ,IsViewed ,DetectedEventType } = audit;
  // const snapurl = SnapshotUrl !== null ? SnapshotUrl : `https://vdointel.online/vdointel/deviceimages/${CameraId}.jpg`
  const { EventNo, EventType,CameraId, ClientCreatedOn, DetectedType,EventTime, devicename, SnapshotUrl, snapshot, VideoUrl ,SupervisorComments ,Priority ,IsFavourite ,IsViewed ,DetectedEventType } = audit;
  const snapurl = SnapshotUrl !== null ? SnapshotUrl : snapshot !== null ?  snapshot : '';

  const IsAgentBased = localStorage.getItem('IsAgentBased');
  const client_id = localStorage.getItem('client_id');
  const useDetectedEventTypeFallback = EVENT_TYPE_FALLBACK_CLIENT_IDS.includes(String(client_id));
  const displayEventType = useDetectedEventTypeFallback
    ? (!isBlankEventType(DetectedEventType) ? DetectedEventType : DetectedType)
    : EventType;
  const agentEventType = useDetectedEventTypeFallback ? displayEventType : DetectedType;
  const formattedDate =EventTime?formatEventTime(EventTime):'';
  const latestFormattedDate =formattedDate;
  const [showMore, setShowMore] = useState(false);

  const [liked, setLiked] = useState(false);

  const handleToggle = () => {
    setLiked(prev => !prev);
  };


  const alignComments1 = (comments)=>{
    // console.log(comments)
    let lines=comments.split('\n')

    return (
      <ul>
        {lines.map((line, index) => (
          <li>
            {line}
          </li>
        ))}
      </ul>
    )
  }


  const alignComments = (comments) => {
    // console.log(comments);
  
    // Replace \n and \N with empty strings
    const cleanedComments = comments.replace(/\\n|\\N/g, '');
    const lines = cleanedComments.split('\n');
  
    return (
      <ul>
        {lines.map((line, index) => (
          <li key={index}>
            {line}
          </li>
        ))}
      </ul>
    );
  }
  

  const [expanded, setExpanded] = useState(false);
  const comment = alignComments(SupervisorComments ? SupervisorComments : '');
  const shouldTruncate = comment.length > MAX_COMMENT_LENGTH;
  const displayComment = expanded || !shouldTruncate ? comment : `${comment.slice(0, MAX_COMMENT_LENGTH)}...`;

  const handleExpandToggle = (e) => {
    e.stopPropagation();
    setExpanded((prev) => !prev);
  };



  return (
    <>
  {IsAgentBased === "0" ? (

<Card
  sx={{
    display: 'flex',
    flexDirection: 'row',
    borderRadius: 2,
    overflow: 'hidden',
    minHeight: 200,
    maxWidth: 500,
    boxShadow: 3,
  }}
>
  {/* IMAGE BLOCK */}
  <Box
    onClick={() => handleDialog(audit)}
    sx={{
      width: '50%',
      minHeight: 200,
      position: 'relative',
      cursor: 'pointer',
      background: 'linear-gradient(to top, rgb(6, 6, 6), 20%, rgb(51, 51, 51))',
      flexShrink: 0,
    }}
  >
    {/* Play Icon */}
    <Avatar
      sx={{
        zIndex: 9,
        top: '45%',
        left: '45%',
        position: 'absolute',
        color: '#2b6cb0', 
        bgcolor: "#333666",
      }}
    >
      <Iconify icon="eva:play-circle-outline" width={30} height={30} />
    </Avatar>

    {/* Snapshot Image */}
    {snapurl && (
      <Box
        component="img"
        src={snapurl}
        alt={ClientCreatedOn}
        onError={(e) => {
          e.target.style.display = 'none';
        }}
        sx={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          display: 'block',
        }}
      />
    )}
  </Box>

  {/* DETAILS BLOCK */}
  <Box sx={{ p: 2, flex: 1 }}>
    <Stack spacing={0.6}>
      <Stack direction="row" spacing={1}>
        <Typography sx={{ fontSize: '0.95rem', fontWeight: 700 }}>Camera:</Typography>
      </Stack>
        <Typography sx={{ fontSize: '0.9rem' }}>{devicename || ''}</Typography>
      
      <Stack direction="row" spacing={1}>
        <Typography sx={{ fontSize: '0.95rem', fontWeight: 700 }}>Event Type:</Typography>
      </Stack>
      <Typography sx={{ fontSize: '0.9rem' }}>{agentEventType || ''}</Typography>


      <Stack direction="row" spacing={1}>
        <Typography sx={{ fontSize: '0.95rem', fontWeight: 700 }}>Member Name:</Typography>
      </Stack>
      <Typography sx={{ fontSize: '0.9rem' }}>John Deo</Typography>

      <Stack direction="row" spacing={1}>
        <Typography sx={{ fontSize: '0.95rem', fontWeight: 700 }}>Event Time:</Typography>
      </Stack>
      <Typography sx={{ fontSize: '0.9rem' }}>{latestFormattedDate || ''}</Typography>

      <Stack direction="row" spacing={1}>
        <Typography sx={{ fontSize: '0.95rem', fontWeight: 700 }}>Event Number:</Typography>
      </Stack>
      <Typography sx={{ fontSize: '0.9rem' }}>{EventNo || ''}</Typography>
    </Stack>
  </Box>
</Card>


    ) : (
      
        // <Card sx={{ p: 1,height:'100%',mt:1}}>
        //   <Grid container spacing={2}>
        //     <Grid item xs={6}>
        //         <Box 
        //           onClick={() => handleDialog(audit)} 
        //           sx={{ 
        //               width: '100%', // occupy 50% of the container width
        //               position: 'relative', 
        //               background: 'linear-gradient(to top, rgb(6, 6, 6), 20%, rgb(51 51 51))', 
        //               cursor: "pointer",
        //              // minHeight:200,
        //               height:225,
        //               display: 'flex',
        //               justifyContent: 'center',
        //               alignItems: 'center'
        //           }}
        //           >
        //           <Avatar
        //               sx={{
        //               zIndex: 9,
        //               // top: '40%',
        //               // left: '45%',
        //               // position: 'absolute',
        //               textTransform: 'uppercase',
        //               bgcolor: green[500]
        //               }}
        //           >
        //               <Iconify icon="eva:play-circle-outline" width={30} height={30} />
        //           </Avatar>
        //           {snapurl && (
        //               <ProductImgStyle alt={ClientCreatedOn} src={snapurl}/>
        //               <ProductImgStyle alt={ClientCreatedOn} src={snapurl}  onError={(e) => {
        //                e.target.style.display = 'none';
        //               }}/>
        //           )}
        //         </Box>
        //     </Grid>
        //     <Grid item xs={6}>
        //           <Box sx={{ width: '90%', p: 0,height:300}}>
        //           {/* <Typography color="gray" sx={{fontSize: "0.75rem"}}>{ClientCreatedOn}</Typography> */}
        //           <Stack direction="row"
        //             justifyContent="flex-start"
        //             alignItems="center"
        //             spacing={1}           
        //             >
        //             <Typography sx={{ fontSize: "1.2rem", fontWeight: 800 }}>Camera: </Typography>
        //           </Stack>
        //           <Stack direction="row"
        //             justifyContent="flex-start"
        //             alignItems="center"
        //             spacing={1}
        //             // sx={{pt: 1}}            
        //             >
        //             <Typography sx={{ fontSize: "1.1rem", textTransform: "capitalize" }}>{devicename}</Typography>
        //           </Stack>
        //           {/* <Stack direction="row"
        //               justifyContent="flex-start"
        //               alignItems="center"
        //               spacing={1}
        //               >
        //               <Typography  sx={{ fontSize: "0.9rem", fontWeight: 800 }}>Audit ID: </Typography>
        //               <Typography sx={{ fontSize: "0.9rem" }}>{EventNo}</Typography>
        //           </Stack> */}
        //           <Stack direction="row"
        //               justifyContent="flex-start"
        //               alignItems="center"
        //               spacing={1}
        //               >
        //               <Typography  sx={{ fontSize: "1.2rem", fontWeight: 800 }}>Priority : </Typography>
        //               <Typography sx={{ fontSize: "1.1rem" }}>{Priority === 0 ? 
                      
        //               <Typography >Normal</Typography>: 
        //               <Typography >High</Typography>
                      
        //               }
                        

        //               </Typography>
        //           </Stack>
        //           <Stack direction="row"
        //               justifyContent="flex-start"
        //               alignItems="center"
        //               spacing={1}
        //               >
        //               <Typography  sx={{ fontSize: "1.2rem", fontWeight: 800 }}>Event Type : </Typography>
        //           </Stack>

        //           {/* <Stack direction="row"
        //             justifyContent="flex-start"
        //             alignItems="center"
        //             spacing={1}           
        //             >
        //               <Typography sx={{ fontSize: "0.9rem" }}>{EventType}</Typography>    
        //           </Stack> */}

        //           <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={1}>
        //             <Typography sx={{ fontSize: "1.1rem" }}>               
        //                 {EventType}       
        //             </Typography>
        //           </Stack>

        //           <Stack direction="row"
        //               justifyContent="flex-start"
        //               alignItems="center"
        //               spacing={1}
        //               >
        //               <Typography  sx={{ fontSize: "1.2rem", fontWeight: 800 }}>Event Time : </Typography>
        //           </Stack>

        //           <Stack direction="row"
        //               justifyContent="flex-start"
        //               alignItems="center"
        //               spacing={1}
        //               >
        //               <Typography sx={{ fontSize: "1.1rem" }}>{latestFormattedDate}</Typography>
        //           </Stack>

        //           <Stack direction="row"
        //               justifyContent="flex-start"
        //               alignItems="center"
        //               spacing={1}
        //               >
        //               <Typography  sx={{ fontSize: "1.2rem", fontWeight: 800 }}>Event Number : </Typography>
        //           </Stack>

        //           <Stack direction="row"
        //               justifyContent="flex-start"
        //               alignItems="center"
        //               spacing={1}
        //               >
        //               <Typography sx={{ fontSize: "1.1rem" }}>{EventNo}</Typography>
        //           </Stack>
        //           {/* {Number(localStorage.getItem("client_id")) === 831 && (
        //               <LoadingButton 
        //               sx={{ mt: 2}}
        //               fullWidth
        //               variant="contained"
        //               loading={isSubmitting}
        //               onClick={sendMail}
        //               >
        //               Send Mail
        //               </LoadingButton>
        //           )}         */}
        //           </Box>
        //     </Grid>
        //     <Grid item xs={12} sx={{ marginTop: -8 }}>
        //           <Box sx={{p: 1}}>
        //             <Typography sx={{ fontSize: "1.2rem", fontWeight: 800 }}>Comment:  </Typography>                 
        //             <Typography sx={{ fontSize: "1.1rem", textTransform: "capitalize",marginLeft:'8px'}}>
        //             {alignComments(SupervisorComments)}
        //           </Typography>                 
        //           </Box>
        //     </Grid>
        //   </Grid>        
        // </Card> 


  

    <Card
  variant="outlined"
  sx={{
    p: 1,
    mt: 1,
    height: '300px',
  }}
  onClick={() => handleDialog(audit)}
>


      {/* <Box sx={{ position: 'absolute', top: 8, right: 8 }} onClick={() => handleDialogFav(audit)} > */}
        {/* <IconButton >
          {IsFavourite === 1 ? (
            <StarIcon style={{ color: 'gold' }} />
          ) : (
            <StarBorderIcon />
          )}
        </IconButton> */}
      {/* </Box> */}
     <Grid container spacing={2} sx={{ flex: 1, height: '100%', mt: -1}}>
        <Grid item xs={12} md={6}>
          <Box
            onClick={() => handleDialog(audit)}
            sx={{
              width: '100%',
              height: '100%',
              position: 'relative',
              background: 'linear-gradient(to top, rgb(6, 6, 6), 20%, rgb(51 51 51))',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              overflow: 'hidden',
              borderRadius: '12px',
            }}
          >

            {snapurl && (
              <Box
                component="img"
                alt={ClientCreatedOn}
                src={snapurl}
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
                sx={{
                  height: '100%',
                  width: '100%',
                  objectFit: 'cover'
                }}
              />
            )}
 <Avatar
  sx={{
    position: 'absolute',
    zIndex: 9,
    textTransform: 'uppercase',
    color: '#2b6cb0',
    bgcolor: "#333666",
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 44,
    height: 44,
  }}
>
  <Iconify icon="eva:play-circle-outline" width={30} height={30} />
</Avatar>

          </Box>
        </Grid>
        <Grid item xs={12} md={6}>

          <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
  <Stack spacing={1}>
              <Typography sx={{ fontSize: "1.1rem", fontWeight: 800 }}>Camera: </Typography>
            </Stack>

            <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={1}>
              <Typography
                sx={{
                  fontSize: "0.9rem",
                  textTransform: (client_id === "1302") ? "none" : "capitalize"
                }}
              >
                {devicename ? devicename : ''}
              </Typography>
            </Stack>
            <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={1}>
              <Typography sx={{ fontSize: "1.1rem", fontWeight: 800 }}>Priority: </Typography>

              <Label
                variant="ghost"
                color={Priority === 1 ? "error" : "success"}
              >
                {Priority === 1 ? "High" : "Normal" || "N/A"}
              </Label>
            </Stack>
            <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={1}>
              <Typography sx={{ fontSize: "1.1rem", fontWeight: 800 }}>Event Type: </Typography>
            </Stack>
            <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={1}>
              <Typography sx={{ fontSize: "0.9rem" }}> {displayEventType || ''}</Typography>
            </Stack>

            <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={1}>
              <Typography sx={{ fontSize: "1.1rem", fontWeight: 800 }}>Event Time: </Typography>
            </Stack>
            <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={1}>
              <Typography sx={{ fontSize: "0.9rem" }}>{latestFormattedDate ? latestFormattedDate : ''}</Typography>
            </Stack>
            <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={1}>
              <Typography sx={{ fontSize: "1.1rem", fontWeight: 800 }}>Event Number: </Typography>
            </Stack>
            <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={1}>
              <Typography sx={{ fontSize: "0.9rem" }}>{EventNo ? EventNo : ''}</Typography>
            </Stack>
          </Box>
        </Grid>
      </Grid>
    </Card>
   
         
    )}

    </>

  );
}
